// extracted by mini-css-extract-plugin
export var button = "style-module--button--9331e";
export var container = "style-module--container--32faf";
export var container_inner = "style-module--container_inner--a2d23";
export var heading = "style-module--heading--03519";
export var tel = "style-module--tel--a2355";